export default {
  hero: {
    object: "Comparaison contrats d'achat",
    title: "Comparez les alternatives à EDF OA",
    description:
      "Explorez les différentes options pour vendre l'énergie produite par vos panneaux solaires. Découvrez les alternatives au contrat de rachat EDF OA et trouvez la solution qui correspond le mieux à vos besoins.",
  },
  offers: {
    "learn-more": "En savoir plus",
    "most-popular": "Le plus populaire",
    "electricity-grid": "Réseau électrique",
    "system-power": "Puissance",
    "subscribed-power": "Puissance souscrite",
    "consumption-client": "Consommation client",
    "rge-installer": "Installateur RGE",
    filters: {
      all: "Tous",
      "virtual-battery": "Batterie virtuelle",
      contract: "Contrat d'achat",
      "price-type": "Type de prix au kWh",
      "starting-fees": "Frais de dossier",
      "additional-fees": "Coûts d'abonnement",
      "electricity-grid": "Disponibilité",
      "system-power": "Puissances photovoltaïques",
      "consumption-client": "Obligation de consommer aussi",
      "requires-rge-installer": "Obligation d'une pose RGE",
    },

    cards: {
      "edf-oa-1": {
        provider: "EDF OA",
        title: "Obligation Achat (S21)",
        description:
          "Tarif d'achat garanti sur 20 ans par l'État en métropole.",
        "price-type": "Prix fixe",
        price: "0,040 € - 0,095 € / kWh", //conditional on system power in kwc
        "starting-fees": "0 €",
        "additional-fees": "0 €",
        eligibility: {
          "electricity-grid": "Métropole",
          "system-power": "0 kWc - 500 kWc",
          "consumption-client": "Non",
          "requires-rge-installer": "Oui",
        },
      },
      "edf-oa-2": {
        provider: "EDF OA",
        title: "Obligation Achat (S24 en ZNI)",
        description: "Tarif d'achat garanti sur 20 ans par l'État en DROM-COM.",
        "price-type": "Prix fixe",
        price: "Jusqu'à 0,1786 € / kWh", //conditional on system power in kwc
        "starting-fees": "0 €",
        "additional-fees": "0 €",
        eligibility: {
          "electricity-grid": "DROM-COM",
          "system-power": "0 kWc - 500 kWc",
          "consumption-client": "Non",
          "requires-rge-installer": "Oui",
        },
      },
      sunology: {
        provider: "Sunology",
        title: "Surplus +",
        description: " Contrat d’achat à un prix fixe",
        "price-type": "Prix fixe",
        price: "0,10 € / kWh	",
        eligibility: {
          "electricity-grid": "Métropole",
          "system-power": "0 kWc - 36 kWc",
          "consumption-client": "Non",
          "requires-rge-installer": " Non",
        },
      },
      "3erl-1": {
        provider: "Association 3ERL",
        title: "Achat du surplus photovoltaïque",
        description:
          "Electricité Ecologique Economique Renouvelable et Locale.",
        "price-type": "Prix variable",
        price: "70% du prix SPOT",
        "starting-fees": "0 €",
        "additional-fees": "0 €",
        eligibility: {
          "electricity-grid": "Métropole",
          "system-power": "9999 kWc",
          "consumption-client": "Non",
          "requires-rge-installer": "Non",
        },
      },
      "ekwateur-1": {
        provider: "Ekwateur",
        title: "Revente avec contrat Ekwateur",
        description: "Offre de rachat du surplus avec les avantages Ekwateur.",
        "price-type": "Prix variable",
        price: "Environ 0,06 € / kWh",
        "starting-fees": "0 €",
        "additional-fees": "1 € par kWc par mois",
        eligibility: {
          "electricity-grid": "Métropole",
          "system-power": "0 kWc - 36 kWc",
          "consumption-client": "Oui",
          "requires-rge-installer": "Non",
        },
      },
      "ekwateur-2": {
        provider: "Ekwateur",
        title: "Revente sans contrat Ekwateur",
        description: "Offre de rachat du surplus sans les avantages Ekwateur.",
        "price-type": "Prix variable",
        price: "Environ 0,04 € / kWh",
        "starting-fees": "150 €",
        "additional-fees": "1 € par kWc par mois",
        eligibility: {
          "electricity-grid": "Métropole",
          "system-power": "0 kWc - 36 kWc",
          "consumption-client": "Non",
          "requires-rge-installer": "Non",
        },
      },
      "urban-solar-1": {
        provider: "Urban Solar Energy",
        title: "Boost Mon Surplus ≤ 36 KVA",
        description:
          "Revente du surplus pour particuliers, sans engagement, sans RGE.",
        "price-type": "Prix variable",
        price: "Environ 0,03 € / kWh",
        "starting-fees": "249 € TTC",
        "additional-fees": "1 € par kWc par mois",
        eligibility: {
          "electricity-grid": "Métropole",
          "system-power": "0 kWc - 36 kWc",
          "consumption-client": "Non",
          "requires-rge-installer": "Non",
        },
      },
      "urban-solar-2": {
        provider: "Urban Solar Energy",
        title: "Boost Mon Surplus > 36 KVA",
        description:
          "Revente du surplus pour professionnels, sans engagement, sans RGE.",
        "price-type": "Prix variable",
        price: "Environ 0,03 € / kWh",
        "starting-fees": "650 € TTC",
        "additional-fees": "1 € par kWc par mois",
        eligibility: {
          "electricity-grid": "Métropole",
          "system-power": "36 kWc - 250 kWc",
          "consumption-client": "Non",
          "requires-rge-installer": "Non",
        },
      },
      "urban-solar-3": {
        provider: "Urban Solar Energy",
        title: "Le Stockage Virtuel (pour particuliers)",
        description:
          "Stockez et déstockez votre électricité non autoconsommée en illimité, sans équipement supplémentaire et en toute liberté.",
        "price-type": "1€ HT par kWc/mois",
        price: "1€ HT par kWc/mois",
        "starting-fees": "299 €",
        "additional-fees": "0 €",
        eligibility: {
          "electricity-grid": "Métropole",
          "system-power": "0 kWc - 36 kWc",
          "consumption-client": "Oui",
          "requires-rge-installer": "Non",
        },
      },
      "urban-solar-4": {
        provider: "Urban Solar Energy",
        title: "Le Stockage Virtuel (pour professionnels)",
        description:
          "Stockez et déstockez votre électricité non autoconsommée en illimité, sans équipement supplémentaire et en toute liberté.",
        "price-type": "1€ HT par kWc/mois",
        price: "1€ HT par kWc/mois",
        "starting-fees": "299 €",
        "additional-fees": "0 €",
        eligibility: {
          "electricity-grid": "Métropole",
          "system-power": "0 kWc - 36 kWc",
          "consumption-client": "Oui",
          "requires-rge-installer": "Non",
        },
      },
      "jpme-1": {
        provider: "JPME",
        title: "E-Surplus Fixe Particuliers",
        description: "Tarif d'achat fixé à vie pour les particuliers.",
        "price-type": "Prix fixe",
        price: "0,08 € / kWh",
        "starting-fees": "499 €",
        "additional-fees": "0 €",
        eligibility: {
          "electricity-grid": "Métropole",
          "system-power": "0 kWc - 36 kWc",
          "consumption-client": "Non",
          "requires-rge-installer": "Non",
        },
      },
      "jpme-2": {
        provider: "JPME",
        title: "E-Surplus Flex Particuliers",
        description:
          "Tarif évolue en fonction des fluctuations du marché SPOT.",
        "price-type": "Prix variable",
        price: "Prix spot",
        "starting-fees": "649 €",
        "additional-fees": "0 €",
        eligibility: {
          "electricity-grid": "Métropole",
          "system-power": "0 kWc - 36 kWc",
          "consumption-client": "Non",
          "requires-rge-installer": "Non",
        },
      },
      "jpme-3": {
        provider: "JPME",
        title: "E-Surplus Fixe Professionnels",
        description: "Tarif d'achat fixé à vie pour les professionels.",
        "price-type": "Prix fixe",
        price: "0,08 € / kWh",
        "starting-fees": "990 €",
        "additional-fees": "0 €",
        eligibility: {
          "electricity-grid": "Métropole",
          "system-power": "36 kWc - 250 kWc",
          "consumption-client": "Non",
          "requires-rge-installer": "Non",
        },
      },
      "jpme-4": {
        provider: "JPME",
        title: "E-Surplus Flex Professionnels",
        description:
          "Tarif évolue en fonction des fluctuations du marché SPOT.",
        "price-type": "Prix variable",
        price: "Prix spot",
        "starting-fees": "990 €",
        "additional-fees": "0 €",
        eligibility: {
          "electricity-grid": "Métropole",
          "system-power": "36 kWc - 250 kWc",
          "consumption-client": "Non",
          "requires-rge-installer": "Non",
        },
      },
      "jpme-e-battery": {
        provider: "JPME",
        title: "E-batterie (3 kVA - 15 kVA)",
        description:
          "L’offre du fournisseur historique de batterie virtuelle de JPME sans abonnement. ",
        "price-type": "Prix variable",
        price: "Frais de dossier 669 €",
        "starting-fees": "990 €",
        "additional-fees": "0 €",
        eligibility: {
          "electricity-grid": "Métropole",
          "system-power": "3 kVA - 15 kVA",
          "consumption-client": "Oui",
          "requires-rge-installer": "Non",
        },
      },
      "jpme-e-battery-2": {
        provider: "JPME",
        title: "E-batterie (18 kVA - 36 kVA)",
        description:
          "L’offre du fournisseur historique de batterie virtuelle de JPME sans abonnement. ",
        "price-type": "Prix variable",
        price: "Frais de dossier 889 €",
        "starting-fees": "990 €",
        "additional-fees": "0 €",
        eligibility: {
          "electricity-grid": "Métropole",
          "system-power": "15 kVA - 36 kVA",
          "consumption-client": "Oui",
          "requires-rge-installer": "Non",
        },
      },
      "my-light-1": {
        provider: "mylight150",
        title: "MySmartBattery",
        description:
          "La batterie virtuelle MySmartBattery, solution de coffret intelligent avec stockage virtuel sans frais kWh à partir de 15€/mois.",
        "price-type": "Inconnu",
        price: "À partir de 15€ / mois",
        "starting-fees": "Inconnu",
        "additional-fees": "Inconnu",
        eligibility: {
          "electricity-grid": "Métropole",
          "system-power": "Inconnu",
          "consumption-client": "Oui",
          "requires-rge-installer": "Non",
        },
      },
      "my-light-2": {
        provider: "mylight150",
        title: "MyBattery",
        description:
          "La batterie virtuelle MyBattery, solution pour stocker votre énergie solaire en illimité, sans matériel nécessaire.",
        "price-type": "1€ HT par kWc/mois",
        price: "1€ HT par kWc/mois",
        "starting-fees": "Inconnu",
        "additional-fees": "Inconnu",
        eligibility: {
          "electricity-grid": "Métropole (Enedis)",
          "subscribed-power": "<36 kVa",
          "consumption-client": "Oui",
          "requires-rge-installer": "Non",
        },
      },
      "octopus-energy-1": {
        provider: "Octopus Energy",
        title: "Offre de rachat SolarPlus",
        description: "Offre pilote chez Octopus d'achat votre énergie.",
        "price-type": "Prix fixe",
        price: "0,13 € / kWh",
        "starting-fees": "0 €",
        "additional-fees": "0 €",
        eligibility: {
          "electricity-grid": "Métropole",
          "system-power": "0 kWc - 36 kWc",
          "consumption-client": "Oui",
          "requires-rge-installer": "Non",
        },
      },
      "octopus-energy-2": {
        provider: "Octopus Energy",
        title: "Octopus Energy Tertiaire",
        description:
          "Tarifs d'achat personnalisés pour les producteurs puissants.",
        "price-type": "Inconnu",
        price: "Inconnu",
        "starting-fees": "Inconnu",
        "additional-fees": "Inconnu",
        eligibility: {
          "electricity-grid": "Métropole",
          "system-power": "36 kWc - 250 kWc",
          "consumption-client": "Oui",
          "requires-rge-installer": "Non",
        },
      },
      "mint-energie-1": {
        provider: "Mint Énergie",
        title: "Rachat d'électricité par Mint Énergie",
        description:
          "Actuellement en refonte de nos offres de rachat de surplus solaire.",
        "price-type": "Inconnu",
        price: "Inconnu",
        "starting-fees": "Inconnu",
        "additional-fees": "Inconnu",
        eligibility: {
          "electricity-grid": "Métropole",
          "system-power": "Inconnu",
          "consumption-client": "Inconnu",
          "requires-rge-installer": "Inconnu",
        },
      },
      "total-energies-1": {
        provider: "Total Energies",
        title: "Contrat d'achat Total Energies",
        description: "Contrat d'achat hors obligation achat.",
        "price-type": "Inconnu",
        price: "Inconnu",
        "starting-fees": "Inconnu",
        "additional-fees": "Inconnu",
        eligibility: {
          "electricity-grid": "Métropole",
          "system-power": "Inconnu",
          "consumption-client": "Inconnu",
          "requires-rge-installer": "Inconnu",
        },
      },
      "enercoop-1": {
        provider: "Enercoop",
        title: "Producteurs moins de 200 MWh/an",
        description:
          "Offre hors obligation achat pour petits collectifs de citoyens ou collectivités.",
        "price-type": "Prix fixe",
        price: "0,065 € / kWh",
        "starting-fees": "0 €",
        "additional-fees": "0 €",
        eligibility: {
          "electricity-grid": "Métropole",
          "system-power": "0 kWc - 36 kWc",
          "consumption-client": "Oui",
          "requires-rge-installer": "Non",
        },
      },
      "enercoop-2": {
        provider: "Enercoop",
        title: "Producteurs plus de 200 MWh/an",
        description:
          "Offre hors obligation achat pour grands collectifs de citoyens ou collectivités.",
        "price-type": "Inconnu",
        price: "Inconnu",
        "starting-fees": "Inconnu",
        "additional-fees": "Inconnu",
        eligibility: {
          "electricity-grid": "Métropole",
          "system-power": "36 kWc - 250 kWc",
          "consumption-client": "Oui",
          "requires-rge-installer": "Non",
        },
      },
      kwatts: {
        provider: "Kwatts",
        title: "Achat de production",
        description: "Achat de production au prix d'écarts de la RTE.",
        "price-type": "Prix du marché",
        price: "Environ 0,05 € / kWh",
        "starting-fees": "Inconnu",
        "additional-fees": "Inconnu",
        eligibility: {
          "electricity-grid": "Métropole",
          "system-power": "0 kWc - 500 kWc",
          "consumption-client": "Non",
          "requires-rge-installer": "Non",
        },
      },
      "my-solar-kit": {
        provider: "MK-Surplus",
        title: "MK-surplus (avec Consuel validée)",
        description:
          "Revente du surplus destiné au clients Mon Kit Solaire pour installation avec Consuel.",
        "price-type": "Prix fixe",
        price: "0,10 € / kWh",
        "starting-fees": "499 €",
        "additional-fees": "0 €",
        eligibility: {
          "electricity-grid": "Enedis",
          "system-power": "0 kVA - 36 kVA",
          "consumption-client": "Non",
          "requires-rge-installer": "Non",
        },
      },
      "my-solar-kit-2": {
        provider: "MK-Surplus",
        title: "MK-surplus (sans Consuel validée)",
        description:
          "Revente du surplus destiné au clients Mon Kit Solaire pour installation sans Consuel.",
        "price-type": "Prix fixe",
        price: "0,10 € / kWh",
        "starting-fees": "699 €",
        "additional-fees": "0 €",
        eligibility: {
          "electricity-grid": "Enedis",
          "system-power": "0 kVA - 36 kVA",
          "consumption-client": "Non",
          "requires-rge-installer": "Non",
        },
      },
    },
  },
  process: {
    radios: {
      "new-project": "Nouveau projet",
      "switch-form-current-contract": "Changement de contrat",
    },
    "new-project": {
      title:
        "Comment vendre son surplus pour valoriser sa production d'électricité solaire ?",
      description:
        "Vente du surplus ou vente en totalité, contrat d'achat ou bien batterie virtuelle - pensez à améliorer la rentabilité de votre investissement.",
      timeline: {
        decision: {
          title: "1. Choisissez votre modèle économique",
          description:
            "Étudiez les alternatives et leur pertinence par rapport à votre gisement solaire et votre consommation d'électricité.",
        },
        install: {
          title: "2. Réalisez la pose avec un professionnel RGE",
          description:
            "Obtenez plusieurs devis pour évaluer les offres et choisissez un poseur sans sous-traitance avec label RGE.",
        },
        enedis: {
          title: "3. Réalisez rapidement la demande de raccordement",
          description:
            "Assurez-vous de la bonne réalisation de la demande de raccordement auprès d'Enedis (ou régie locale) pour sécuriser le dossier.",
        },
        "finish-grid-connection": {
          title:
            "4. Obtenez la mise en service de votre installation photovoltaïque",
          description:
            "Réduisez les délais avec un excellent suivi du dossier et faites-vous faire l'attestation de conformité du Consuel.",
        },
        sign: {
          title: "5. Signez avec le EDF OA ou autre co-contractant",
          description:
            "Démarrez votre expérience solaire sur le bon pied dès le premier jour avec un contrat qui rentabilise chaque kWh produit.",
        },
      },
    },
    "switch-from-current-contract": {
      title: "Comment changer de contrat d'achat ?",
      description: "",
      // Maarten said we have to ask Naina for this timeline
      timeline: {},
    },
  },
  CTA: {
    title:
      "Démarrez votre projet solaire dès aujourd'hui avec le contrat d'achat de votre choix",
    description: "",
    button: "Commencez aujourd'hui",
  },
}
